// extracted by mini-css-extract-plugin
module.exports = {"pageDescription":"AccreditationsDescription_pageDescription__bLl3r"};